import { put, call, takeLatest } from "redux-saga/effects";
import { showModal, hideModal } from "../actions/modal.actions";
import { hideNotification } from "../actions/notifications.actions";
import { setAuthError } from "../actions/authPayment.actions";
import { setMfaOptions,mfaMaxAttempts } from "../actions/mfa.actions";
import {
  getMfaOptions,
  sendMfaCode,
  confirmMfaCode,
} from "../utils/requests";

const showLoadingModal = () => {
  return showModal("loading", "Loading...");
};

// Get mfa options
export function* getMfaOptionsSaga() {
  try {
    yield put(hideNotification());
    yield put(showLoadingModal());

    const response = yield call(getMfaOptions);

    const options = {
      phoneNumbers: response.PhoneNumbers,
      emailAddresses: response.EmailAddresses,
      mfaMemberId: response.MfaMemberId,
    };

    yield put(setMfaOptions(options));

    yield put(hideModal("loading"));
  } catch (error) {
    console.log(error);

    yield put(setAuthError());
    yield put(hideModal("loading"));
  }
}

export function* watchGetMfaOptions() {
  yield takeLatest("MFA_GET_OPTIONS", getMfaOptionsSaga);
}

// Submit mfa preference and request code be sent
export function* submitMfaPreferenceSaga({ method, id, callback }) {
  try {
    yield put(hideNotification());
    yield put(showLoadingModal());

    const response = yield call(sendMfaCode, method, id);

    if (callback) {
      callback(response);
    }

    yield put(hideModal("loading"));
  } catch (error) {
    console.log(error);

    yield put(setAuthError());
    yield put(hideModal("loading"));
  }
}

export function* watchSubmitMfaPreference() {
  yield takeLatest("MFA_SUBMIT_PREFERENCE", submitMfaPreferenceSaga);
}

// Submit user's code input for confirmation
export function* submitMfaCodeSaga({ code, callback }) {
  try {
    yield put(hideNotification());
    yield put(showLoadingModal());

    const response = yield call(confirmMfaCode, code);

    yield put(hideModal("loading"));

    if (response.LockedOut) {
      yield put(mfaMaxAttempts());
    } else {
      if (callback) {
        callback(response);
      }
    }
  } catch (error) {
    console.log(error);

    yield put(mfaMaxAttempts());
    yield put(hideModal("loading"));
  }
}

export function* watchSubmitMfaCode() {
  yield takeLatest("MFA_SUBMIT_CODE", submitMfaCodeSaga);
}



// WEBPACK FOOTER //
// ./src/sagas/mfa.sagas.js